import './packages-box.scss'

export const component = {
    name: 'packages-box'
}


// WEBPACK FOOTER //
// ./app/theme/components/packages-box/packages-box.js